<template>
    <van-row class="selectedcss">
        <van-col span="24">
            <van-row>
                <van-col span="24" class="seleTitle">{{ $t('prolist.mintitle' ) }}</van-col>
            </van-row>
            <van-row class="seleconext">
                <van-col span="24">
                    <van-row class="tabcont">
                        <van-col span="24">
                            <router-link :to="`/Details?id=${selected.id}`">
                                <van-row>
                                    <van-col span="18" class="tab_tit">{{selected.title}}</van-col>
                                    <van-col span="6"><van-tag round type="primary"></van-tag></van-col>
                                </van-row>
                                <van-row class="list_middle">
                                    <van-col span="7" class="rate">{{selected.rate}}%</van-col>
                                    <van-col span="7"></van-col>
                                    <van-col span="10" class="buybtn"><van-tag color="#7232dd" class="tag">{{selected.tag}}</van-tag></van-col>
                                </van-row>
                                <van-row>
                                    <van-col span="7">{{ $t('index.rate' )}}</van-col>
                                    <van-col span="10"></van-col>
                                    <van-col span="7"></van-col>
                                </van-row>
                                <van-row>
                                    <van-col span="24" class="comment"><span style="font-weight: bold">{{ $t('prolist.comment') }}</span> | {{selected.comment}}</van-col>
                                </van-row>
                            </router-link>
                        </van-col>
                    </van-row>
                </van-col>
            </van-row>
        </van-col>
    </van-row>
</template>

<script>
    export default {
        name: "Selected",
        data(){
            return{

            }
        },
        props:['selected']
    }
</script>

<style scoped lang="scss">
    .selectedcss{
        overflow: hidden;
        text-align: left;
        height: 0;
        width: 92%;
        margin: 10px auto;
        padding-bottom: 45%;

        background: url("~@/assets/images/bg_financial_card.png");
        background-size: 100% 100%;
        a{
            color: #666666;
        }

        .seleTitle{
            text-align: left;
            color: white;
            text-indent: 10px;
            height:30px;
            line-height: 30px;
            font-size: 15px;
            font-weight: bold;
        }
        .seleconext{
            height: 130px;
            width: 96%;
            margin: 0 auto;
            background: white;
            .tabcont{
                margin: 10px;
                padding-bottom: 10px;
                .tab_tit{
                    color: #666;
                    font-size: 16px;
                    font-weight: bold;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                }
                .list_middle{
                    height: 35px;
                    line-height: 35px;
                    width: 100%;
                    .rate{
                        height: 35px;
                        line-height: 35px;
                        color: red;
                        font-size: 19px;
                        font-weight: bold;

                    }
                    .buybtn{
                        text-align: right;
                        .tag{
                            padding: 10px;
                        }
                    }
                }
                .comment{
                    margin: 8px auto 0 auto;
                    background: #ececec url("~@/assets/images/ic_comment.png")no-repeat left 10%;
                    background-size: 9% 60%;
                    padding: 5px;
                    border-radius: 5px;
                }

            }
        }
    }
</style>
